import { useEffect, useRef } from 'react'

export const useClickOutside = <T extends HTMLElement = HTMLElement>(callback: () => void) => {
  const ref = useRef<T>(null)

  useEffect(() => {
    const onClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        callback()
      }
    }
    document.addEventListener('mousedown', onClickOutside)
    return () => document.removeEventListener('mousedown', onClickOutside)
  }, [callback])

  return ref
}
